import React from 'react';
import { useColorMode, IconButton, Tooltip } from '@chakra-ui/react';
import { SunIcon, MoonIcon } from '@chakra-ui/icons';

interface ColorModeToggleProps {
  className?: string;
}

const ColorModeToggle: React.FC<ColorModeToggleProps> = ({ className }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  
  return (
    <Tooltip 
      label={colorMode === 'light' ? 'Přepnout na tmavý režim' : 'Přepnout na světlý režim'}
      aria-label="Color mode toggle tooltip"
    >
      <IconButton
        aria-label="Toggle color mode"
        icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
        onClick={toggleColorMode}
        variant="ghost"
        size="md"
        className={className}
        color={colorMode === 'dark' ? 'white' : 'black'}
      />
    </Tooltip>
  );
};

export default ColorModeToggle;
